/**
 * KeypadButtonComponent
 */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { E2E_ATTRIBUTES } from '@shared/types/enums/e2e-attributes.enum';

import type { KeypadButton } from '../classes/KeyPad.type';

@Component({
  selector: 'keypad-button',
  styleUrls: ['./keypad-button.component.scss'],
  templateUrl: './keypad-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KeypadButtonComponent {
  @Input('keyPadButton') public keyPadButton: KeypadButton;
  // eslint-disable-next-line @angular-eslint/no-output-rename
  @Output('clicked') public click: EventEmitter<KeypadButton> =
    new EventEmitter();

  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;

  public onClick(): void {
    if (this.keyPadButton.disabled) {
      return;
    }

    this.click.emit(this.keyPadButton);
  }
}
